import Vue from 'vue'
import Vuex from 'vuex'
import ls from 'local-storage'
import jwt from 'jwt-decode';

Vue.use(Vuex)

const state = {
  isLogged: !!ls('token'),
  token: ls('token') ? jwt(ls('token')) : ``,
  jwt: ls('token') ? ls('token') : ``,
}

const mutations = {
  LOGIN_USER(state) {
    state.isLogged = true
    state.token = ls('token') ? jwt(ls('token')) : ``;
    state.jwt = ls('token')
  },

  LOGOUT_USER(state) {
    state.isLogged = false
  }
}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js